activ.directive('projectGridView', function() {
    return {
        replace: true,
        restrict: 'E',
        templateUrl: "./views/projectGridView.html?v=" + version,
        scope: true,
        link: function(scope, element, attrs) {

        }
    };
});